import { useQuery } from 'react-query';
import { useService } from 'shared/providers';
import { Brands, CustomerShipTo } from 'shared/types';

export function useCustomerShipTo(brand: Brands, customerId: string) {
  const { quoteService } = useService();
  const { data, isLoading, isFetching } = useQuery<CustomerShipTo[], Error>(
    ['customer-ship-to', customerId],
    () => quoteService.getCustomerShipTo(brand, customerId),
    {
      retry: false,
      enabled: Boolean(customerId),
    }
  );
  return { addresses: data, isLoading, isFetching } as const;
}
